export default __webpack_public_path__ + "static/media/bonus.430b1544.svg";